// import axios from "axios";
// import { useEffect, useRef, useState } from "react";
// import {
//     FaBriefcase,
//     FaCalendarCheck,
//     FaDownload,
//     FaEye,
//     FaFileMedical,
//     FaIdCard,
//     FaRoad,
//     FaStar,
//     FaTimesCircle,
//     FaUser,
//     FaUserGraduate,
//     FaUserTie
// } from "react-icons/fa";
// import { API_BASE_URL, API_DOMAIN } from "../utils/config";

// const DetailItem = ({ icon, label, value }) => (
//     <div className="flex items-start gap-3">
//         <div className="mt-1 text-blue-500">{icon}</div>
//         <div>
//             <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
//             <p className="text-sm font-bold text-gray-800">{value}</p>
//         </div>
//     </div>
// );

// const JobApplicants = () => {
//     const [applications, setApplications] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [scoreFilter, setScoreFilter] = useState(0);
//     const [roleFilter, setRoleFilter] = useState("");
//     const [dateFilter, setDateFilter] = useState("");
//     const [roleSearchQuery, setRoleSearchQuery] = useState("");
//     const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
//     const roleDropdownRef = useRef(null);
//     const [roles, setRoles] = useState([]);
//     const [selectedApplicant, setSelectedApplicant] = useState(null);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [departmentFilter, setDepartmentFilter] = useState("");
//     const [departments, setDepartments] = useState([]);

//     // Profile Modal
//     const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
//     const [profileApp, setProfileApp] = useState(null);
//     const [profileDocs, setProfileDocs] = useState(null);
//     const [profileMedical, setProfileMedical] = useState([]);
//     const [profileExperience, setProfileExperience] = useState([]);
//     const [profileTab, setProfileTab] = useState("basic");
//     const [profileLoading, setProfileLoading] = useState(false);

//     // Pagination states
//     const [pagination, setPagination] = useState({
//         currentPage: 1,
//         totalPages: 1,
//         totalCount: 0,
//         limit: 10,
//     });

//     const [isPackageModalOpen, setIsPackageModalOpen] = useState(false);
//     const [packageSalary, setPackageSalary] = useState("");

//     useEffect(() => {
//         fetchApplications();
//         fetchRoles();

//         const handleClickOutside = (event) => {
//             if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
//                 setIsRoleDropdownOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     const fetchRoles = async () => {
//         try {
//             const res = await axios.get(`${API_BASE_URL}/jobs/all`);
//             if (res.data.success) {
//                 const rolesData = res.data.jobPosts || [];

//                 // Fetch Unique Roles
//                 const formattedRoles = rolesData.map((job, index) => ({
//                     _id: job._id || index,
//                     name: job.role
//                 }));
//                 const uniqueRoles = Array.from(new Set(formattedRoles.map(r => r.name)))
//                     .filter(name => name && !name.toLowerCase().includes("resign"))
//                     .map(name => formattedRoles.find(r => r.name === name));
//                 setRoles(uniqueRoles);

//                 // Fetch Unique Departments
//                 const uniqueDepts = Array.from(new Set(rolesData.map(job => job.department)))
//                     .filter(dept => dept)
//                     .sort();
//                 setDepartments(uniqueDepts);
//             }
//         } catch (err) {
//             console.error("Failed to fetch roles:", err);
//         }
//     };

//     const fetchApplications = async () => {
//         try {
//             setLoading(true);
//             const res = await axios.get(`${API_BASE_URL}/applications/all`);
//             if (res.data.success) {
//                 setApplications(res.data.applications);
//             }
//         } catch (err) {
//             setError("Failed to fetch applications");
//             console.error(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const formatDocumentUrl = (filePath) => {
//         if (!filePath) return "";
//         const relativePath = filePath.includes("uploads")
//             ? "uploads/" + filePath.split(/uploads[\\/]/).pop().replace(/\\/g, "/")
//             : filePath.replace(/\\/g, "/");
//         return `${API_BASE_URL.replace("/api", "")}/${relativePath}`;
//     };

//     const handleOpenModal = (app) => {
//         setSelectedApplicant(app);
//         setIsModalOpen(true);
//     };

//     const handleOpenProfileModal = async (app) => {
//         setProfileApp(app);
//         setProfileTab("basic");
//         setProfileDocs(null);
//         setProfileMedical([]);
//         setProfileExperience([]);
//         setIsProfileModalOpen(true);
//         setProfileLoading(true);
//         try {
//             const candidateId = app.candidateId?._id || app.candidateId;
//             if (candidateId) {
//                 const [docsRes, medRes, expRes] = await Promise.allSettled([
//                     axios.get(`${API_BASE_URL}/candidate/admin/${candidateId}`),
//                     axios.get(`${API_BASE_URL}/medical-certificates/employee/${candidateId}`),
//                     axios.get(`${API_BASE_URL}/candidate/all-experiences`)
//                 ]);
//                 if (docsRes.status === "fulfilled" && docsRes.value.data?.success) {
//                     setProfileDocs(docsRes.value.data.data?.documents || null);
//                 }
//                 if (medRes.status === "fulfilled" && medRes.value.data?.success) {
//                     setProfileMedical(medRes.value.data.data || []);
//                 }
//                 if (expRes.status === "fulfilled" && expRes.value.data?.success) {
//                     // Filter experiences for this specific candidate by email or candidateId
//                     const allExp = expRes.value.data.data || [];
//                     const filteredExp = allExp.filter(exp =>
//                         (exp.candidateId?._id === candidateId) ||
//                         (exp.candidateId?.email === app.email) ||
//                         (exp.email === app.email)
//                     );
//                     setProfileExperience(filteredExp);
//                 }
//             }
//         } catch (e) {
//             console.error("Profile load error:", e);
//         } finally {
//             setProfileLoading(false);
//         }
//     };

//     const handleOpenAssessmentModal = (app) => {
//         window.location.href = `/score?search=${app.firstName}`;
//     };

//     const handleOpenPackageModal = (app) => {
//         setSelectedApplicant(app);
//         setPackageSalary(app.finalSalary || app.expectedCTC || "");
//         setIsPackageModalOpen(true);
//     };

//     const handleSavePackage = async () => {
//         try {
//             const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
//                 applicationId: selectedApplicant._id,
//                 finalSalary: packageSalary,
//             });
//             if (res.data.success) {
//                 alert("Package updated successfully!");
//                 setIsPackageModalOpen(false);
//                 fetchApplications();
//             }
//         } catch (err) {
//             console.error("Save package error:", err);
//             alert("Failed to save package");
//         }
//     };

//     const filteredApplications = applications.filter(app => {
//         // Hide Resignations
//         if (app.jobId?.role?.toLowerCase().includes("resign") || app.status === "Resigned" || app.documentType === "Resignation") return false;

//         // NEW: Robust Filter to Hide Short-Term Jobs
//         const isShortJob =
//             app.jobId?.jobType === "short" ||
//             app.jobType === "short" ||
//             (app.jobId && (app.jobId.startTime || app.jobId.endTime || app.jobId.totalDuration));

//         if (isShortJob) return false;

//         const query = searchQuery.toLowerCase();
//         const matchesSearch =
//             `${app.firstName} ${app.lastName}`.toLowerCase().includes(query) ||
//             (app.jobId?.role || "").toLowerCase().includes(query) ||
//             (app.mobile || "").toLowerCase().includes(query);

//         const matchesScore = (app.technicalScore || 0) >= scoreFilter;
//         const matchesRole = roleFilter ? (app.jobId?.role === roleFilter) : true;
//         const matchesDept = departmentFilter ? (app.jobId?.department === departmentFilter) : true;

//         let matchesDate = true;
//         if (dateFilter) {
//             const appDate = new Date(app.appliedAt).toISOString().split('T')[0];
//             matchesDate = appDate === dateFilter;
//         }

//         return matchesSearch && matchesScore && matchesRole && matchesDept && matchesDate;
//     });

//     // Pagination Handlers
//     const handleItemsPerPageChange = (limit) => {
//         setPagination({
//             currentPage: 1,
//             limit: limit,
//             totalCount: filteredApplications.length,
//             totalPages: Math.ceil(filteredApplications.length / limit)
//         });
//     };

//     const handlePrevPage = () => {
//         if (pagination.currentPage > 1) {
//             setPagination(prev => ({
//                 ...prev,
//                 currentPage: prev.currentPage - 1
//             }));
//         }
//     };

//     const handleNextPage = () => {
//         if (pagination.currentPage < pagination.totalPages) {
//             setPagination(prev => ({
//                 ...prev,
//                 currentPage: prev.currentPage + 1
//             }));
//         }
//     };

//     const handlePageClick = (page) => {
//         setPagination(prev => ({
//             ...prev,
//             currentPage: page
//         }));
//     };

//     const getPageNumbers = () => {
//         const pageNumbers = [];
//         for (let i = 1; i <= pagination.totalPages; i++) {
//             if (
//                 i === 1 ||
//                 i === pagination.totalPages ||
//                 (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)
//             ) {
//                 pageNumbers.push(i);
//             } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
//                 pageNumbers.push("...");
//             }
//         }
//         return pageNumbers;
//     };

//     // Update pagination when filtered results change
//     useEffect(() => {
//         setPagination(prev => ({
//             ...prev,
//             totalCount: filteredApplications.length,
//             totalPages: Math.ceil(filteredApplications.length / prev.limit),
//             currentPage: 1
//         }));
//     }, [filteredApplications.length, searchQuery, scoreFilter, roleFilter, departmentFilter, dateFilter]);

//     // Calculate pagination
//     const indexOfLastItem = pagination.currentPage * pagination.limit;
//     const indexOfFirstItem = indexOfLastItem - pagination.limit;
//     const currentItems = filteredApplications.slice(indexOfFirstItem, indexOfLastItem);

//     // Clear all filters
//     const clearFilters = () => {
//         setSearchQuery("");
//         setScoreFilter(0);
//         setRoleFilter("");
//         setDepartmentFilter("");
//         setDateFilter("");
//         setRoleSearchQuery("");
//     };

//     const handleDownload = () => {
//         if (filteredApplications.length === 0) {
//             alert("No data available to download.");
//             return;
//         }

//         const headers = [
//             "Candidate Name",
//             "Email",
//             "Mobile",
//             "Applied Role",
//             "Department",
//             "Status",
//             "Applied At",
//             "Experience (Years)",
//             "Highest Qualification",
//             "Institution",
//             "Percentage",
//             "Current Company",
//             "Current CTC",
//             "Expected CTC",
//             "Final Salary",
//             "Location",
//             "Technical Score",
//             "Appearance Score",
//             "Knowledge Score",
//             "Overall Rating"
//         ];

//         const csvContent = [
//             headers.join(","),
//             ...filteredApplications.map(app => [
//                 `"${app.firstName} ${app.lastName}"`,
//                 `"${app.email || "N/A"}"`,
//                 `"${app.mobile || "N/A"}"`,
//                 `"${app.jobId?.role || "N/A"}"`,
//                 `"${app.jobId?.department || "N/A"}"`,
//                 `"${app.status || "Applied"}"`,
//                 `"${new Date(app.appliedAt).toLocaleDateString()}"`,
//                 `"${app.experience || 0}"`,
//                 `"${app.highestQualification || "N/A"}"`,
//                 `"${app.institution || "N/A"}"`,
//                 `"${app.percentage || 0}%"`,
//                 `"${app.companyName || app.currentCompany || "N/A"}"`,
//                 `"${app.currentCTC || "N/A"}"`,
//                 `"${app.expectedCTC || "N/A"}"`,
//                 `"${app.finalSalary || "N/A"}"`,
//                 `"${app.currentLocation || "N/A"}"`,
//                 app.technicalScore || 0,
//                 app.appearanceScore || 0,
//                 app.workKnowledge || 0,
//                 app.overallRating || 0
//             ].join(","))
//         ].join("\n");

//         const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         const filename = `Applicants_Report_${new Date().toISOString().split('T')[0]}.csv`;
//         link.setAttribute("href", url);
//         link.setAttribute("download", filename);
//         link.style.visibility = 'hidden';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     const handleUpdateScore = async (id, field, value) => {
//         const numericValue = (field === "status") ? value : Number(value);

//         try {
//             const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
//                 applicationId: id,
//                 [field]: numericValue,
//             });
//             if (res.data.success) {
//                 setApplications((prev) =>
//                     prev.map((app) => (app._id === id ? { ...app, [field]: numericValue } : app))
//                 );
//             }
//         } catch (err) {
//             console.error("Update score error:", err);
//         }
//     };

//     const Info = ({ label, value }) => (
//         <div className="flex justify-between">
//             <span className="text-gray-500">{label}</span>
//             <span className="font-medium text-gray-800 text-right">
//                 {value || "N/A"}
//             </span>
//         </div>
//     );

//     const ScoreMini = ({ label, score }) => (
//         <div>
//             <p className="text-xs text-gray-500">{label}</p>
//             <p className={`text-sm font-semibold ${score >= 80
//                 ? "text-green-600"
//                 : score >= 50
//                     ? "text-yellow-600"
//                     : "text-red-600"
//                 }`}>
//                 {score || 0}
//             </p>
//         </div>
//     );

//     return (
//         <div className="w-full min-h-screen p-2">
//             {/* Filters Section */}
//             <div className="p-3 mb-3 bg-white rounded-lg shadow-md">
//                 <div className="flex flex-wrap items-center gap-2">

//                     {/* Search Bar */}
//                     <div className="relative flex-[2] min-w-[300px]">
//                         <FaUserGraduate className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
//                         <input
//                             type="text"
//                             placeholder="Search name, mobile, role..."
//                             value={searchQuery}
//                             onChange={(e) => setSearchQuery(e.target.value)}
//                             className="w-full pl-10 pr-3 py-2 text-xs border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all shadow-sm"
//                         />
//                     </div>

//                     {/* Role Filter Button */}
//                     <div className="relative" ref={roleDropdownRef}>
//                         <button
//                             onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
//                             className={`h-9 px-4 text-xs font-medium rounded-md transition flex items-center gap-2 ${roleFilter
//                                     ? 'bg-blue-600 text-white hover:bg-blue-700'
//                                     : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
//                                 }`}
//                         >
//                             <FaBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
//                         </button>

//                         {/* Role Filter Dropdown */}
//                         {isRoleDropdownOpen && (
//                             <div className="absolute z-50 mt-1 w-56 bg-white border border-gray-200 rounded-md shadow-xl max-h-60 overflow-y-auto">
//                                 <div className="p-2 border-b border-gray-100 bg-gray-50">
//                                     <div className="relative">
//                                         <FaUserTie className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
//                                         <input
//                                             type="text"
//                                             className="w-full py-1.5 pl-8 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
//                                             placeholder="Search roles..."
//                                             value={roleSearchQuery}
//                                             onChange={(e) => setRoleSearchQuery(e.target.value)}
//                                             onClick={(e) => e.stopPropagation()}
//                                             autoFocus
//                                         />
//                                     </div>
//                                 </div>
//                                 <div
//                                     onClick={() => {
//                                         setRoleFilter('');
//                                         setIsRoleDropdownOpen(false);
//                                         setRoleSearchQuery('');
//                                     }}
//                                     className={`px-4 py-2.5 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${!roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
//                                         }`}
//                                 >
//                                     All Roles
//                                 </div>
//                                 {roles
//                                     .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
//                                     .map((r) => (
//                                         <div
//                                             key={r._id}
//                                             onClick={() => {
//                                                 setRoleFilter(r.name);
//                                                 setIsRoleDropdownOpen(false);
//                                                 setRoleSearchQuery('');
//                                             }}
//                                             className={`px-4 py-2 text-xs hover:bg-blue-50 cursor-pointer ${roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
//                                                 }`}
//                                         >
//                                             {r.name}
//                                         </div>
//                                     ))}
//                                 {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
//                                     <div className="px-3 py-2 text-xs text-gray-400 text-center">
//                                         No roles found
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                     </div>

//                     {/* Score Filter */}
//                     <div className="relative w-[140px]">
//                         <select
//                             className="w-full pl-3 pr-8 py-2 text-xs border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none transition-all shadow-sm cursor-pointer"
//                             value={scoreFilter}
//                             onChange={(e) => setScoreFilter(Number(e.target.value))}
//                         >
//                             <option value="0">All Scores</option>
//                             <option value="60">60% & Above</option>
//                             <option value="70">70% & Above</option>
//                             <option value="80">80% & Above</option>
//                             <option value="90">90% & Above</option>
//                         </select>
//                         <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none text-gray-400">
//                             <FaStar className="text-[10px]" />
//                         </div>
//                     </div>

//                     {/* Date Filter */}
//                     <div className="relative w-[140px]">
//                         <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-500 pointer-events-none font-bold">
//                             Date:
//                         </span>
//                         <input
//                             type="date"
//                             value={dateFilter}
//                             onChange={(e) => setDateFilter(e.target.value)}
//                             onClick={(e) => e.target.showPicker && e.target.showPicker()}
//                             className="w-full pl-12 pr-2 py-2 text-xs border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all cursor-pointer"
//                         />
//                     </div>

//                     {/* Department Filter */}
//                     <div className="relative w-[160px]">
//                         <select
//                             className="w-full pl-3 pr-8 py-2 text-xs border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none shadow-sm transition-all cursor-pointer"
//                             value={departmentFilter}
//                             onChange={(e) => setDepartmentFilter(e.target.value)}
//                         >
//                             <option value="">All Departments</option>
//                             {departments.map((dept, idx) => (
//                                 <option key={idx} value={dept}>{dept}</option>
//                             ))}
//                         </select>
//                         <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none text-gray-400">
//                             <FaBriefcase className="text-[10px]" />
//                         </div>
//                     </div>

//                     {/* Download Button */}
//                     <button
//                         onClick={handleDownload}
//                         className="h-9 px-5 text-[11px] font-black text-white bg-gradient-to-r from-emerald-500 to-teal-600 rounded-md hover:from-emerald-600 hover:to-teal-700 transition shadow-md flex items-center gap-2 uppercase tracking-widest ml-auto"
//                     >
//                         <FaDownload /> Download Data
//                     </button>

//                     {/* Clear Filters Button */}
//                     {(searchQuery || scoreFilter > 0 || roleFilter || departmentFilter || dateFilter) && (
//                         <button
//                             onClick={clearFilters}
//                             className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition"
//                         >
//                             Clear
//                         </button>
//                     )}
//                 </div>
//             </div>

//             {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">{error}</div>}

//             <div className="p-0 mb-0 bg-white border shadow-lg rounded-2xl">
//                 {loading ? (
//                     <div className="flex flex-col items-center justify-center py-20 gap-4">
//                         <div className="w-10 h-10 border-4 border-indigo-50 border-t-indigo-600 rounded-full animate-spin"></div>
//                         <p className="text-xs font-bold text-gray-400 animate-pulse uppercase tracking-wider">Loading Applicants...</p>
//                     </div>
//                 ) : filteredApplications.length > 0 ? (
//                     <div className="overflow-x-auto bg-white shadow-lg rounded-xl">
//                         <table className="min-w-full">
//                             <thead className="text-sm text-left text-white bg-gradient-to-r from-green-500 to-blue-600">
//                                 <tr>
//                                     <th className="py-2 text-center">Candidate Name</th>
//                                     <th className="py-2 text-center">Applied Role</th>
//                                     <th className="py-2 text-center">Contact</th>
//                                     <th className="py-2 text-center">Average Score (100)</th>
//                                     <th className="py-2 text-center">Status</th>
//                                     <th className="py-2 text-center">Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {currentItems.map((app) => (
//                                     <tr key={app._id} className="border-b hover:bg-gray-50 transition-colors">
//                                         <td className="px-2 py-2 font-medium text-center">
//                                             <div className="text-gray-900 whitespace-nowrap">{app.firstName} {app.lastName}</div>
//                                             <div className="text-[10px] text-gray-600">{new Date(app.appliedAt).toLocaleDateString()}</div>
//                                         </td>
//                                         <td className="px-2 py-2 text-center">
//                                             <span className="inline-block px-2 py-1 bg-blue-50 text-blue-600 text-[10px] rounded-full">
//                                                 {app.jobId?.role || "System Specialist"}
//                                             </span>
//                                         </td>
//                                         <td className="px-2 py-2 text-center text-gray-600">
//                                             <div className="flex flex-col items-center">
//                                                 <span>{app.mobile}</span>
//                                             </div>
//                                         </td>
//                                         <td className="px-2 py-2 text-center">
//                                             <div className="flex items-center justify-center gap-1">
//                                                 {app.assessmentResults && app.assessmentResults.length > 0 ? (
//                                                     <div className="flex items-center gap-1">
//                                                         <span className="text-[10px] text-gray-400 font-bold">AVG</span>
//                                                         <span className={`w-16 p-1.5 border rounded-lg text-xs text-center font-bold bg-gray-100 ${Math.round(app.assessmentResults.reduce((sum, res) => sum + (res.score || 0), 0) / app.assessmentResults.length) >= 80
//                                                                 ? "text-green-600"
//                                                                 : Math.round(app.assessmentResults.reduce((sum, res) => sum + (res.score || 0), 0) / app.assessmentResults.length) >= 50
//                                                                     ? "text-yellow-600"
//                                                                     : "text-red-600"
//                                                             }`}>
//                                                             {Math.round(app.assessmentResults.reduce((sum, res) => sum + (res.score || 0), 0) / app.assessmentResults.length)}
//                                                         </span>
//                                                     </div>
//                                                 ) : (
//                                                     <input
//                                                         type="number"
//                                                         min="0"
//                                                         max="100"
//                                                         className="w-20 p-1.5 border rounded-lg text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50"
//                                                         value={app.technicalScore || 0}
//                                                         onChange={(e) => handleUpdateScore(app._id, "technicalScore", e.target.value)}
//                                                     />
//                                                 )}
//                                             </div>
//                                         </td>
//                                         <td className="px-2 py-2 text-center">
//                                             <div className="flex flex-col items-center gap-1">
//                                                 <span className={`px-2 py-1 rounded-full text-[10px] ${app.status === 'Selected' ? 'bg-green-100 text-green-700' :
//                                                     app.status === 'Rejected' ? 'bg-red-100 text-red-700' :
//                                                         'bg-yellow-100 text-yellow-700'
//                                                     }`}>
//                                                     {(app.status || "Applied").toUpperCase()}
//                                                 </span>
//                                                 {(app.interviewStatus === 'Invited' || app.interviewStatus === 'Rescheduled') && app.candidateInterviewStatus && app.candidateInterviewStatus !== 'Pending' && (
//                                                     <span className={`text-[8px] font-black uppercase tracking-tighter ${app.candidateInterviewStatus === 'Confirmed' ? 'text-indigo-600' : 'text-rose-600'}`}>
//                                                         Interview {app.candidateInterviewStatus}
//                                                     </span>
//                                                 )}
//                                             </div>
//                                         </td>
//                                         <td className="px-2 py-2 text-center">
//                                             <div className="flex justify-center gap-2 flex-wrap">
//                                                 <button
//                                                     onClick={() => handleOpenProfileModal(app)}
//                                                     className="px-3 py-1 bg-violet-50 text-violet-700 hover:bg-violet-600 hover:text-white rounded-xl transition-all duration-300 shadow-sm hover:shadow-md border border-violet-200 flex items-center justify-center gap-1.5 text-[10px] font-bold"
//                                                 >
//                                                     <FaUser className="text-xs" /> Profile
//                                                 </button>
//                                                 <button
//                                                     onClick={() => handleOpenModal(app)}
//                                                     className="px-3 py-1 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-xl transition-all duration-300 shadow-sm hover:shadow-md border border-indigo-100 flex items-center justify-center gap-1.5 text-[10px] font-bold"
//                                                 >
//                                                     <FaEye className="text-xs" /> View
//                                                 </button>
//                                                 <button
//                                                     onClick={() => handleOpenAssessmentModal(app)}
//                                                     className="px-3 py-1 bg-gradient-to-r from-indigo-500 to-blue-600 text-white rounded-xl hover:from-indigo-600 hover:to-blue-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
//                                                 >
//                                                     <FaStar className="text-xs" /> Score
//                                                 </button>
//                                                 <button
//                                                     onClick={() => {
//                                                         if (app.resume) {
//                                                             window.open(formatDocumentUrl(app.resume), '_blank');
//                                                         }
//                                                     }}
//                                                     className="text-gray-600 hover:text-blue-600 transition flex items-center gap-1 text-[10px]"
//                                                     title="View Resume"
//                                                 >
//                                                     <FaDownload className="text-xs" /> Resume
//                                                 </button>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>

//                         {/* Pagination */}
//                         {filteredApplications.length > 0 && (
//                             <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 sm:flex-row">
//                                 <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
//                                     <span>Showing</span>
//                                     <span className="font-medium">
//                                         {indexOfFirstItem + 1}
//                                     </span>
//                                     <span>to</span>
//                                     <span className="font-medium">
//                                         {Math.min(indexOfLastItem, filteredApplications.length)}
//                                     </span>
//                                     <span>of</span>
//                                     <span className="font-medium">
//                                         {filteredApplications.length}
//                                     </span>
//                                     <span>results</span>

//                                     <select
//                                         value={pagination.limit}
//                                         onChange={(e) => {
//                                             const newLimit = Number(e.target.value);
//                                             handleItemsPerPageChange(newLimit);
//                                         }}
//                                         className="p-1 ml-2 text-sm border rounded-lg"
//                                     >
//                                         <option value={5}>5</option>
//                                         <option value={10}>10</option>
//                                         <option value={20}>20</option>
//                                         <option value={50}>50</option>
//                                     </select>
//                                 </div>

//                                 <div className="flex items-center gap-2 mt-2 sm:mt-0">
//                                     <button
//                                         onClick={handlePrevPage}
//                                         disabled={pagination.currentPage === 1}
//                                         className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${pagination.currentPage === 1
//                                                 ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                                                 : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//                                             }`}
//                                     >
//                                         Previous
//                                     </button>

//                                     <div className="flex items-center gap-1">
//                                         {getPageNumbers().map((page, index) => (
//                                             <button
//                                                 key={index}
//                                                 onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
//                                                 disabled={page === "..."}
//                                                 className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${page === "..."
//                                                         ? "text-gray-500 cursor-default"
//                                                         : pagination.currentPage === page
//                                                             ? "bg-blue-600 text-white"
//                                                             : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
//                                                     }`}
//                                             >
//                                                 {page}
//                                             </button>
//                                         ))}
//                                     </div>

//                                     <button
//                                         onClick={handleNextPage}
//                                         disabled={pagination.currentPage === pagination.totalPages}
//                                         className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${pagination.currentPage === pagination.totalPages
//                                                 ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                                                 : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//                                             }`}
//                                     >
//                                         Next
//                                     </button>
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 ) : (
//                     <div className="p-12 text-center">
//                         <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4 text-gray-300">
//                             <FaUserGraduate size={32} />
//                         </div>
//                         <h3 className="text-lg font-medium text-gray-800">No applicants yet</h3>
//                         <p className="text-gray-500">New job applications will appear here once candidates apply.</p>
//                     </div>
//                 )}
//             </div>

//             {/* Candidate Details Modal */}
//             {isModalOpen && selectedApplicant && (
//                 <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
//                     <div className="bg-white w-full max-w-3xl rounded-xl shadow-xl relative overflow-hidden">

//                         {/* Close Button */}
//                         <button
//                             onClick={() => setIsModalOpen(false)}
//                             className="absolute top-4 right-4 text-gray-400 hover:text-red-500"
//                         >
//                             <FaTimesCircle size={18} />
//                         </button>

//                         {/* Header */}
//                         <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
//                             <div>
//                                 <h2 className="text-lg font-semibold text-gray-800">
//                                     {selectedApplicant.firstName} {selectedApplicant.lastName}
//                                 </h2>
//                                 <p className="text-xs text-gray-500">
//                                     {selectedApplicant.jobId?.role || selectedApplicant.role || "Applicant"}
//                                     {selectedApplicant.jobId?.department && ` • ${selectedApplicant.jobId.department}`}
//                                 </p>
//                             </div>

//                             <span className={`px-3 py-1 text-xs font-semibold rounded-full
//                                 ${selectedApplicant.status === "Pending"
//                                     ? "bg-yellow-100 text-yellow-700"
//                                     : selectedApplicant.status === "Selected"
//                                         ? "bg-green-100 text-green-700"
//                                         : "bg-red-100 text-red-700"}`}>
//                                 {selectedApplicant.status}
//                             </span>
//                         </div>

//                         {/* Body */}
//                         <div className="p-6 text-sm text-gray-700 space-y-6 max-h-[75vh] overflow-y-auto">

//                             {/* Basic Info */}
//                             <div>
//                                 <h3 className="text-xs font-semibold text-gray-500 uppercase mb-3">
//                                     Basic Information
//                                 </h3>
//                                 <div className="grid grid-cols-2 gap-y-2 gap-x-6">
//                                     <Info label="Email" value={selectedApplicant.email} />
//                                     <Info label="Mobile" value={selectedApplicant.mobile} />
//                                     <Info label="Location" value={selectedApplicant.currentLocation} />
//                                     <Info label="Notice Period" value={selectedApplicant.noticePeriod || "Immediate"} />
//                                 </div>
//                             </div>

//                             {/* Education */}
//                             <div>
//                                 <h3 className="text-xs font-semibold text-gray-500 uppercase mb-3">
//                                     Education
//                                 </h3>
//                                 <div className="grid grid-cols-2 gap-y-2 gap-x-6">
//                                     <Info label="Qualification" value={selectedApplicant.highestQualification} />
//                                     <Info label="Institution" value={selectedApplicant.institution} />
//                                     <Info label="Department" value={selectedApplicant.department} />
//                                     <Info label="Percentage" value={selectedApplicant.percentage ? `${selectedApplicant.percentage}%` : "N/A"} />
//                                 </div>
//                             </div>

//                             {/* Experience */}
//                             <div>
//                                 <h3 className="text-xs font-semibold text-gray-500 uppercase mb-3">
//                                     Experience
//                                 </h3>
//                                 <div className="grid grid-cols-2 gap-y-2 gap-x-6">
//                                     <Info label="Total Exp" value={`${selectedApplicant.experience || 0} Years`} />
//                                     <Info label="Company" value={selectedApplicant.companyName || selectedApplicant.currentCompany} />
//                                     <Info label="Current CTC" value={selectedApplicant.currentCTC} />
//                                     <Info label="Expected CTC" value={selectedApplicant.expectedCTC} />
//                                 </div>
//                             </div>

//                             {/* Skills */}
//                             {selectedApplicant.skills && (
//                                 <div>
//                                     <h3 className="text-xs font-semibold text-gray-500 uppercase mb-3">
//                                         Skills
//                                     </h3>
//                                     <div className="flex flex-wrap gap-2">
//                                         {selectedApplicant.skills.split(",").map((skill, i) => (
//                                             <span
//                                                 key={i}
//                                                 className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-md"
//                                             >
//                                                 {skill.trim()}
//                                             </span>
//                                         ))}
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Scores */}
//                             <div>
//                                 <h3 className="text-xs font-semibold text-gray-500 uppercase mb-3">
//                                     Assessment Scores
//                                 </h3>

//                                 <div className="grid grid-cols-4 gap-4 text-center">
//                                     <ScoreMini label="Tech" score={selectedApplicant.technicalScore} />
//                                     <ScoreMini label="Appear" score={selectedApplicant.appearanceScore} />
//                                     <ScoreMini label="Knowledge" score={selectedApplicant.workKnowledge} />
//                                     <ScoreMini label="Overall" score={selectedApplicant.overallRating} />
//                                 </div>
//                             </div>

//                             {/* Interview Confirmation */}
//                             {(selectedApplicant.interviewStatus === 'Invited' || selectedApplicant.interviewStatus === 'Rescheduled') && (
//                                 <div className={`p-4 rounded-xl border ${selectedApplicant.candidateInterviewStatus === 'Confirmed' ? 'bg-indigo-50 border-indigo-100' : selectedApplicant.candidateInterviewStatus === 'Declined' ? 'bg-red-50 border-red-100' : 'bg-amber-50 border-amber-100'}`}>
//                                     <div className="flex items-center justify-between mb-2">
//                                         <h3 className="text-xs font-bold text-gray-700 uppercase flex items-center gap-2">
//                                             <FaCalendarCheck className={selectedApplicant.candidateInterviewStatus === 'Confirmed' ? 'text-indigo-500' : 'text-gray-400'} /> Interview Confirmation
//                                         </h3>
//                                         <span className={`px-3 py-1 text-[10px] font-bold rounded-full uppercase tracking-widest ${selectedApplicant.candidateInterviewStatus === 'Confirmed' ? 'bg-indigo-100 text-indigo-700' : selectedApplicant.candidateInterviewStatus === 'Declined' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
//                                             {selectedApplicant.candidateInterviewStatus || 'Pending'}
//                                         </span>
//                                     </div>
//                                     <div className="grid grid-cols-2 gap-4 mt-3">
//                                         <Info label="Scheduled Time" value={selectedApplicant.interviewTime} />
//                                         <Info label="Interview Mode" value={selectedApplicant.interviewMode || "Online"} />
//                                     </div>
//                                     {selectedApplicant.candidateInterviewNote && (
//                                         <div className="mt-3 p-3 bg-white rounded-lg border border-gray-100 text-xs text-gray-600 italic">
//                                             "{selectedApplicant.candidateInterviewNote}"
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {/* Comment */}
//                             {selectedApplicant.comment && (
//                                 <div className="text-xs bg-gray-50 p-3 rounded-md border text-gray-600">
//                                     {selectedApplicant.comment}
//                                 </div>
//                             )}
//                         </div>

//                         {/* Footer */}
//                         <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
//                             <button
//                                 onClick={() => {
//                                     if (selectedApplicant?.resume) {
//                                         window.open(formatDocumentUrl(selectedApplicant.resume), "_blank");
//                                     }
//                                 }}
//                                 className="px-4 py-2 bg-blue-600 text-white text-xs rounded-md hover:bg-blue-700"
//                             >
//                                 View Resume
//                             </button>

//                             <button
//                                 onClick={() => setIsModalOpen(false)}
//                                 className="px-4 py-2 bg-gray-800 text-white text-xs rounded-md hover:bg-black"
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Salary Package Modal */}
//             {isPackageModalOpen && (
//                 <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
//                     <div className="bg-white rounded-2xl max-w-md w-full p-8 shadow-2xl relative animate-in fade-in zoom-in duration-300">
//                         <button
//                             onClick={() => setIsPackageModalOpen(false)}
//                             className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all"
//                         >
//                             <FaTimesCircle />
//                         </button>

//                         <div className="text-center mb-8">
//                             <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
//                                 <FaBriefcase size={28} />
//                             </div>
//                             <h2 className="text-2xl font-black text-gray-800">Salary Package</h2>
//                             <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest mt-1">Negotiation & Finalization</p>
//                         </div>

//                         <div className="space-y-6">
//                             <div className="grid grid-cols-2 gap-4">
//                                 <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
//                                     <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Budget Salary</p>
//                                     <p className="text-sm font-bold text-gray-800">{selectedApplicant?.jobId?.salary || "N/A"}</p>
//                                 </div>
//                                 <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
//                                     <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Previous Salary</p>
//                                     <p className="text-sm font-bold text-gray-800">{selectedApplicant?.currentCTC || "N/A"}</p>
//                                 </div>
//                             </div>

//                             <div>
//                                 <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Final Agreed Salary</label>
//                                 <div className="relative">
//                                     <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-bold">₹</div>
//                                     <input
//                                         type="text"
//                                         placeholder="e.g. 12,00,000"
//                                         className="w-full pl-10 pr-4 py-4 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
//                                         value={packageSalary}
//                                         onChange={(e) => setPackageSalary(e.target.value)}
//                                     />
//                                 </div>
//                                 <p className="text-[9px] text-gray-400 mt-2 px-1 font-medium italic">* This value will be used in the official offer letter.</p>
//                             </div>

//                             <button
//                                 onClick={handleSavePackage}
//                                 className="w-full py-4 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-2xl font-black text-xs uppercase tracking-[0.2em] shadow-lg shadow-blue-200 hover:shadow-blue-300 hover:-translate-y-0.5 transition-all duration-300"
//                             >
//                                 Save Package Details
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* ====== PROFILE MODAL ====== */}
//             {isProfileModalOpen && profileApp && (
//                 <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm p-2">
//                     <div className="bg-white w-full max-w-4xl rounded-2xl shadow-2xl relative overflow-hidden flex flex-col max-h-[94vh]">

//                         {/* gradient header */}
//                         <div className="bg-gradient-to-r from-violet-600 via-indigo-600 to-blue-600 px-6 py-5 flex items-center gap-4">
//                             <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center text-white text-2xl font-black shrink-0">
//                                 {profileApp.firstName?.[0]}{profileApp.lastName?.[0]}
//                             </div>
//                             <div className="flex-1 min-w-0">
//                                 <h2 className="text-white text-lg font-black truncate">{profileApp.firstName} {profileApp.lastName}</h2>
//                                 <p className="text-white/70 text-xs">{profileApp.jobId?.role || "—"} &bull; {profileApp.email}</p>
//                             </div>
//                             <span className={`px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest ${profileApp.status === "Selected" ? "bg-green-400/30 text-green-100" : profileApp.status === "Rejected" ? "bg-red-400/30 text-red-100" : "bg-yellow-400/30 text-yellow-100"}`}>
//                                 {profileApp.status}
//                             </span>
//                             <button onClick={() => setIsProfileModalOpen(false)} className="text-white/60 hover:text-white ml-2">
//                                 <FaTimesCircle size={20} />
//                             </button>
//                         </div>

//                         {/* tabs */}
//                         <div className="flex border-b border-gray-100 bg-gray-50 shrink-0">
//                             {[
//                                 { id: "basic", label: "Basic Details", icon: <FaUser /> },
//                                 { id: "docs", label: "Personal Docs", icon: <FaIdCard /> },
//                                 { id: "medical", label: "Medical", icon: <FaFileMedical /> },
//                                 { id: "journey", label: "Emp Journey", icon: <FaRoad /> },
//                             ].map(tab => (
//                                 <button
//                                     key={tab.id}
//                                     onClick={() => setProfileTab(tab.id)}
//                                     className={`flex items-center gap-1.5 px-4 py-3 text-xs font-bold transition-all border-b-2 ${profileTab === tab.id ? "border-violet-600 text-violet-700 bg-white" : "border-transparent text-gray-500 hover:text-gray-700"}`}
//                                 >
//                                     {tab.icon} {tab.label}
//                                 </button>
//                             ))}
//                         </div>

//                         {/* body */}
//                         <div className="overflow-y-auto flex-1 p-5">
//                             {profileLoading && (
//                                 <div className="flex items-center justify-center py-16 gap-3">
//                                     <div className="w-8 h-8 border-4 border-violet-100 border-t-violet-600 rounded-full animate-spin" />
//                                     <span className="text-xs text-gray-400 font-bold uppercase tracking-widest">Loading Profile...</span>
//                                 </div>
//                             )}

//                             {!profileLoading && profileTab === "basic" && (
//                                 <div className="space-y-5">
//                                     {/* Personal */}
//                                     <Section title="Personal Information">
//                                         <Grid2>
//                                             <PField label="Full Name" value={`${profileApp.firstName} ${profileApp.lastName}`} />
//                                             <PField label="Email" value={profileApp.email} />
//                                             <PField label="Mobile" value={profileApp.mobile} />
//                                             <PField label="Date of Birth" value={profileApp.dob ? new Date(profileApp.dob).toLocaleDateString() : "—"} />
//                                             <PField label="Address" value={profileApp.address} />
//                                             <PField label="Current Location" value={profileApp.currentLocation} />
//                                         </Grid2>
//                                     </Section>
//                                     {/* Education */}
//                                     <Section title="Education">
//                                         <Grid2>
//                                             <PField label="Qualification" value={profileApp.highestQualification} />
//                                             <PField label="Institution" value={profileApp.institution} />
//                                             <PField label="Department" value={profileApp.department} />
//                                             <PField label="Percentage" value={profileApp.percentage ? `${profileApp.percentage}%` : "—"} />
//                                             <PField label="Passing Year" value={profileApp.passingYear} />
//                                         </Grid2>
//                                     </Section>
//                                     {/* Experience */}
//                                     <Section title="Work & Compensation">
//                                         <Grid2>
//                                             <PField label="Total Experience" value={profileApp.experience ? `${profileApp.experience} yrs` : "—"} />
//                                             <PField label="Current Company" value={profileApp.companyName || profileApp.currentCompany} />
//                                             <PField label="Current CTC" value={profileApp.currentCTC} />
//                                             <PField label="Expected CTC" value={profileApp.expectedCTC} />
//                                             <PField label="Notice Period" value={profileApp.noticePeriod || "Immediate"} />
//                                             <PField label="Date of Joining" value={profileApp.dateOfJoining} />
//                                             <PField label="Final Salary" value={profileApp.finalSalary} />
//                                             <PField label="Probation" value={profileApp.probationPeriod} />
//                                         </Grid2>
//                                     </Section>
//                                     {/* Skills */}
//                                     {profileApp.skills && (
//                                         <Section title="Skills">
//                                             <div className="flex flex-wrap gap-2">
//                                                 {profileApp.skills.split(",").map((s, i) => (
//                                                     <span key={i} className="px-3 py-1 bg-violet-50 text-violet-700 text-xs rounded-full border border-violet-100 font-medium">{s.trim()}</span>
//                                                 ))}
//                                             </div>
//                                         </Section>
//                                     )}
//                                     {/* Resume */}
//                                     {profileApp.resume && (
//                                         <button onClick={() => window.open(formatDocumentUrl(profileApp.resume), "_blank")}
//                                             className="w-full py-2.5 bg-gradient-to-r from-violet-600 to-indigo-600 text-white rounded-xl text-xs font-black uppercase tracking-widest hover:opacity-90 transition">
//                                             📄 View Resume
//                                         </button>
//                                     )}
//                                 </div>
//                             )}

//                             {!profileLoading && profileTab === "docs" && (
//                                 <div className="space-y-4">
//                                     {!profileDocs ? (
//                                         <EmptyState icon="📂" msg="No personal documents found for this candidate." />
//                                     ) : (
//                                         <>
//                                             {/* File Docs */}
//                                             <Section title="Uploaded Documents">
//                                                 <div className="grid grid-cols-2 gap-3">
//                                                     {[
//                                                         { key: "aadharCard", label: "Aadhar Card" },
//                                                         { key: "panCard", label: "PAN Card" },
//                                                         { key: "tenthCertificate", label: "10th Certificate" },
//                                                         { key: "twelfthCertificate", label: "12th Certificate" },
//                                                         { key: "graduationCertificate", label: "Graduation Certificate" },
//                                                         { key: "experienceLetters", label: "Experience Letter" },
//                                                         { key: "passportPhoto", label: "Passport Photo" },
//                                                     ].map(({ key, label }) => {
//                                                         const doc = profileDocs[key];
//                                                         return (
//                                                             <div key={key} className="flex items-center justify-between p-3 rounded-xl border border-gray-100 bg-gray-50">
//                                                                 <div>
//                                                                     <p className="text-xs font-bold text-gray-700">{label}</p>
//                                                                     {doc?.uploadedAt && <p className="text-[9px] text-gray-400 mt-0.5">{new Date(doc.uploadedAt).toLocaleDateString()}</p>}
//                                                                 </div>
//                                                                 {doc?.url ? (
//                                                                     <button onClick={() => window.open(`${API_DOMAIN}${doc.url}`, "_blank")}
//                                                                         className="px-2 py-1 bg-blue-600 text-white rounded-lg text-[10px] font-bold hover:bg-blue-700 transition">View</button>
//                                                                 ) : (
//                                                                     <span className="text-[10px] text-gray-400 bg-gray-200 px-2 py-1 rounded-lg">Not Uploaded</span>
//                                                                 )}
//                                                             </div>
//                                                         );
//                                                     })}
//                                                 </div>
//                                             </Section>
//                                             {/* Bank */}
//                                             {profileDocs.bankDetails?.accountNumber && (
//                                                 <Section title="Bank Details">
//                                                     <Grid2>
//                                                         <PField label="Bank Name" value={profileDocs.bankDetails.bankName} />
//                                                         <PField label="Account No." value={profileDocs.bankDetails.accountNumber} />
//                                                         <PField label="IFSC Code" value={profileDocs.bankDetails.ifscCode} />
//                                                     </Grid2>
//                                                 </Section>
//                                             )}
//                                             {/* Emergency Contacts */}
//                                             {profileDocs.emergencyContact1?.name && (
//                                                 <Section title="Emergency Contacts">
//                                                     <Grid2>
//                                                         <PField label="Contact 1 Name" value={profileDocs.emergencyContact1.name} />
//                                                         <PField label="Phone" value={profileDocs.emergencyContact1.phone} />
//                                                         <PField label="Relationship" value={profileDocs.emergencyContact1.relationship} />
//                                                         {profileDocs.emergencyContact2?.name && <>
//                                                             <PField label="Contact 2 Name" value={profileDocs.emergencyContact2.name} />
//                                                             <PField label="Phone" value={profileDocs.emergencyContact2.phone} />
//                                                             <PField label="Relationship" value={profileDocs.emergencyContact2.relationship} />
//                                                         </>}
//                                                     </Grid2>
//                                                 </Section>
//                                             )}
//                                         </>
//                                     )}
//                                 </div>
//                             )}

//                             {!profileLoading && profileTab === "medical" && (
//                                 <div>
//                                     {profileMedical.length === 0 ? (
//                                         <EmptyState icon="🏥" msg="No medical certificates found for this candidate." />
//                                     ) : (
//                                         <div className="space-y-3">
//                                             {profileMedical.map((cert, i) => {
//                                                 const expiry = cert.expiryDate ? new Date(cert.expiryDate) : null;
//                                                 const isExpired = expiry && expiry < new Date();
//                                                 return (
//                                                     <div key={i} className="flex items-center justify-between p-4 rounded-xl border border-gray-100 bg-gray-50 hover:bg-white hover:shadow-sm transition">
//                                                         <div className="flex items-center gap-3">
//                                                             <div className={`w-10 h-10 rounded-full flex items-center justify-center text-lg ${isExpired ? "bg-red-100" : "bg-green-100"}`}>
//                                                                 🏥
//                                                             </div>
//                                                             <div>
//                                                                 <p className="text-sm font-bold text-gray-800">{cert.employeeName || cert.candidateName || "—"}</p>
//                                                                 <p className="text-[10px] text-gray-400">
//                                                                     Reg: {cert.registrationDate ? new Date(cert.registrationDate).toLocaleDateString() : "—"}
//                                                                     &nbsp;&bull;&nbsp;Exp: {expiry ? expiry.toLocaleDateString() : "—"}
//                                                                 </p>
//                                                             </div>
//                                                         </div>
//                                                         <div className="flex items-center gap-2">
//                                                             <span className={`text-[9px] font-black px-2 py-1 rounded-full uppercase tracking-widest ${isExpired ? "bg-red-100 text-red-600" : "bg-green-100 text-green-700"}`}>
//                                                                 {isExpired ? "Expired" : "Valid"}
//                                                             </span>
//                                                             {cert.documentUrl && (
//                                                                 <button onClick={() => window.open(`${API_DOMAIN}${cert.documentUrl}`, "_blank")}
//                                                                     className="px-2 py-1 bg-blue-600 text-white rounded-lg text-[10px] font-bold hover:bg-blue-700 transition">View</button>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 );
//                                             })}
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {!profileLoading && profileTab === "journey" && (
//                                 <div className="space-y-4">
//                                     {/* ── Professional History Timeline ── */}
//                                     <div>
//                                         <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Professional History</p>

//                                         {profileExperience.length === 0 ? (
//                                             <div className="flex flex-col items-center justify-center py-10 text-center bg-gray-50 rounded-xl border border-dashed border-gray-200">
//                                                 <span className="text-4xl mb-2">💼</span>
//                                                 <p className="text-xs text-gray-400 font-medium italic">No previous working history recorded.</p>
//                                             </div>
//                                         ) : (
//                                             <div className="relative pl-8 border-l-[3px] border-dashed border-gray-200/60 ml-4 space-y-8">
//                                                 {profileExperience.map((exp, eIdx) => {
//                                                     const formatExpDate = (d) => {
//                                                         if (!d) return "Present";
//                                                         return new Date(d).toLocaleDateString("en-US", { month: "short", year: "numeric" });
//                                                     };
//                                                     const renderDocUrl = (path) => {
//                                                         if (!path) return "#";
//                                                         if (path.startsWith("http")) return path;
//                                                         const norm = path.replace(/\\/g, "/");
//                                                         if (norm.includes("/uploads/")) return `${API_DOMAIN}/uploads/${norm.split("/uploads/")[1]}`;
//                                                         return `${API_DOMAIN}/${norm.startsWith("/") ? norm.substring(1) : norm}`;
//                                                     };
//                                                     const isCurrent = !exp.endDate;
//                                                     return (
//                                                         <div key={eIdx} className="relative">
//                                                             {/* Timeline dot */}
//                                                             <div className={`absolute -left-[45px] top-5 w-6 h-6 rounded-full border-[5px] border-white shadow-md ${isCurrent ? "bg-emerald-500 shadow-emerald-200" : "bg-blue-600"}`} />

//                                                             <div className={`bg-white rounded-xl p-4 border shadow-sm hover:border-blue-200 transition-all duration-300 ${isCurrent ? "border-emerald-200 bg-emerald-50/20" : "border-gray-100"}`}>
//                                                                 <div className="flex flex-col gap-4">
//                                                                     {/* Header */}
//                                                                     <div>
//                                                                         <div className="flex items-center gap-2 flex-wrap">
//                                                                             <h5 className="text-sm font-black text-gray-900 tracking-tight">{exp.role}</h5>
//                                                                             <span className="px-2 py-0.5 bg-blue-50 text-blue-600 text-[9px] font-bold uppercase tracking-wider rounded-md border border-blue-100">
//                                                                                 Record {profileExperience.length - eIdx}
//                                                                             </span>
//                                                                             {isCurrent && (
//                                                                                 <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 text-[9px] font-bold uppercase tracking-wider rounded-md border border-emerald-200 animate-pulse">
//                                                                                     Current
//                                                                                 </span>
//                                                                             )}
//                                                                         </div>
//                                                                         <p className="text-gray-600 font-bold text-xs mt-1 flex items-center gap-1.5">
//                                                                             <span className="text-gray-400">🏢</span> {exp.companyName}
//                                                                         </p>
//                                                                     </div>

//                                                                     {/* Details grid */}
//                                                                     <div className="grid grid-cols-3 gap-3">
//                                                                         <div className="flex items-start gap-2">
//                                                                             <span className="mt-0.5 text-blue-500 text-xs">📅</span>
//                                                                             <div>
//                                                                                 <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">Duration</p>
//                                                                                 <p className="text-xs font-bold text-gray-800">{formatExpDate(exp.startDate)} – {formatExpDate(exp.endDate)}</p>
//                                                                             </div>
//                                                                         </div>
//                                                                         <div className="flex items-start gap-2">
//                                                                             <span className="mt-0.5 text-blue-500 text-xs">📍</span>
//                                                                             <div>
//                                                                                 <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">Location</p>
//                                                                                 <p className="text-xs font-bold text-gray-800">{exp.location}</p>
//                                                                             </div>
//                                                                         </div>
//                                                                         <div className="flex items-start gap-2">
//                                                                             <span className="mt-0.5 text-blue-500 text-xs">💰</span>
//                                                                             <div>
//                                                                                 <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">Annual CTC</p>
//                                                                                 <p className="text-xs font-bold text-gray-800">{exp.salary}</p>
//                                                                             </div>
//                                                                         </div>
//                                                                     </div>

//                                                                     {/* Documents */}
//                                                                     <div className="flex gap-2 pt-2 border-t border-gray-100">
//                                                                         {exp.offerLetter ? (
//                                                                             <a href={renderDocUrl(exp.offerLetter)} target="_blank" rel="noreferrer"
//                                                                                 className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-50 text-gray-700 hover:bg-blue-600 hover:text-white rounded-lg text-[9px] font-bold uppercase tracking-wider transition-all border border-gray-200 hover:border-blue-600 shadow-sm">
//                                                                                 📄 Offer Letter
//                                                                             </a>
//                                                                         ) : (
//                                                                             <div className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-50/50 text-gray-300 rounded-lg text-[9px] font-medium uppercase tracking-wider border border-dashed border-gray-200">
//                                                                                 No Letter
//                                                                             </div>
//                                                                         )}
//                                                                         {exp.payslip ? (
//                                                                             <a href={renderDocUrl(exp.payslip)} target="_blank" rel="noreferrer"
//                                                                                 className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-50 text-gray-700 hover:bg-blue-600 hover:text-white rounded-lg text-[9px] font-bold uppercase tracking-wider transition-all border border-gray-200 hover:border-blue-600 shadow-sm">
//                                                                                 📄 Salary Payslip
//                                                                             </a>
//                                                                         ) : (
//                                                                             <div className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-50/50 text-gray-300 rounded-lg text-[9px] font-medium uppercase tracking-wider border border-dashed border-gray-200">
//                                                                                 No Payslip
//                                                                             </div>
//                                                                         )}
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     );
//                                                 })}
//                                             </div>
//                                         )}
//                                     </div>

//                                     {/* Application Timeline */}
//                                     <Section title="Recruitment Timeline">
//                                         <div className="space-y-2">
//                                             {[
//                                                 { label: "Applied", date: profileApp.appliedAt, color: "bg-blue-500" },
//                                                 { label: "Interview Invited", date: profileApp.interviewTime, color: "bg-violet-500" },
//                                                 { label: "Offer Sent", date: profileApp.offerSentAt, color: "bg-green-500" },
//                                                 { label: "Resignation Submitted", date: profileApp.resignationSentAt, color: "bg-red-500" },
//                                             ].filter(e => e.date).map((event, i) => (
//                                                 <div key={i} className="flex items-center gap-3">
//                                                     <div className={`w-2.5 h-2.5 rounded-full shrink-0 ${event.color}`} />
//                                                     <div className="flex-1 flex items-center justify-between p-2.5 bg-gray-50 rounded-lg border border-gray-100">
//                                                         <p className="text-xs font-bold text-gray-700">{event.label}</p>
//                                                         <p className="text-[10px] text-gray-400">{new Date(event.date).toLocaleString()}</p>
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </Section>
//                                     {/* Document History */}
//                                     {profileApp.documentHistory?.length > 0 && (
//                                         <Section title="Document History">
//                                             <div className="space-y-2">
//                                                 {profileApp.documentHistory.map((doc, i) => (
//                                                     <div key={i} className="p-3 rounded-xl border border-gray-100 bg-gray-50 flex items-center justify-between">
//                                                         <div>
//                                                             <span className={`text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mr-2 ${doc.documentType === "Offer" ? "bg-green-100 text-green-700" :
//                                                                     doc.documentType === "Agreement" ? "bg-blue-100 text-blue-700" :
//                                                                         doc.documentType === "Warning" ? "bg-red-100 text-red-700" :
//                                                                             "bg-gray-200 text-gray-600"
//                                                                 }`}>{doc.documentType}</span>
//                                                             <span className="text-[10px] text-gray-400">{doc.sentAt ? new Date(doc.sentAt).toLocaleDateString() : "—"}</span>
//                                                             {doc.signedAt && <span className="text-[10px] text-green-600 ml-2">✔ Signed {new Date(doc.signedAt).toLocaleDateString()}</span>}
//                                                         </div>
//                                                         <div className="flex gap-1">
//                                                             {doc.attachmentPath && (
//                                                                 <button onClick={() => window.open(formatDocumentUrl(doc.attachmentPath), "_blank")}
//                                                                     className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-[9px] font-bold">Doc</button>
//                                                             )}
//                                                             {doc.signedPath && (
//                                                                 <button onClick={() => window.open(formatDocumentUrl(doc.signedPath), "_blank")}
//                                                                     className="px-2 py-0.5 bg-green-100 text-green-700 rounded text-[9px] font-bold">Signed</button>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         </Section>
//                                     )}
//                                     {/* Interview */}
//                                     {profileApp.interviewStatus === "Invited" && (
//                                         <Section title="Interview Details">
//                                             <Grid2>
//                                                 <PField label="Subject" value={profileApp.interviewSubject} />
//                                                 <PField label="Mode" value={profileApp.interviewMode} />
//                                                 <PField label="Scheduled At" value={profileApp.interviewTime} />
//                                                 <PField label="Candidate Response" value={profileApp.candidateInterviewStatus} />
//                                             </Grid2>
//                                             {profileApp.candidateInterviewNote && (
//                                                 <p className="mt-2 text-xs italic text-gray-500 p-2 bg-gray-50 rounded-lg border">"{profileApp.candidateInterviewNote}"</p>
//                                             )}
//                                         </Section>
//                                     )}
//                                     {/* Resignation */}
//                                     {profileApp.resignationLetter && (
//                                         <Section title="Resignation">
//                                             <PField label="Status" value={profileApp.resignationStatus} />
//                                             <p className="mt-2 text-xs text-gray-600 bg-red-50 p-3 rounded-lg border border-red-100">{profileApp.resignationLetter}</p>
//                                         </Section>
//                                     )}
//                                 </div>
//                             )}
//                         </div>

//                         {/* footer */}
//                         <div className="px-6 py-3 border-t border-gray-100 flex justify-end bg-gray-50 shrink-0">
//                             <button onClick={() => setIsProfileModalOpen(false)}
//                                 className="px-5 py-2 bg-gray-800 text-white text-xs rounded-xl font-bold hover:bg-black transition">
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//         </div>
//     );
// };

// // ---- Helper sub-components ----
// const Section = ({ title, children }) => (
//     <div>
//         <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">{title}</p>
//         <div className="bg-white rounded-xl border border-gray-100 p-4">{children}</div>
//     </div>
// );
// const Grid2 = ({ children }) => <div className="grid grid-cols-2 gap-x-6 gap-y-2">{children}</div>;
// const PField = ({ label, value }) => (
//     <div className="flex flex-col py-1 border-b border-gray-50">
//         <span className="text-[9px] text-gray-400 uppercase font-black tracking-widest">{label}</span>
//         <span className="text-xs font-semibold text-gray-800 mt-0.5">{value || "—"}</span>
//     </div>
// );
// const EmptyState = ({ icon, msg }) => (
//     <div className="flex flex-col items-center justify-center py-16 text-center">
//         <span className="text-5xl mb-3">{icon}</span>
//         <p className="text-sm text-gray-400 font-medium">{msg}</p>
//     </div>
// );

// export default JobApplicants;



import axios from "axios";
import { useEffect, useRef, useState } from "react";
import {
    FaBriefcase,
    FaCalendarCheck,
    FaDownload,
    FaEye,
    FaStar,
    FaTimesCircle,
    FaUserGraduate,
    FaUserTie
} from "react-icons/fa";
import { API_BASE_URL } from "../utils/config";

const DetailItem = ({ icon, label, value }) => (
    <div className="flex items-start gap-3">
        <div className="mt-1 text-blue-500">{icon}</div>
        <div>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
            <p className="text-sm font-bold text-gray-800">{value}</p>
        </div>
    </div>
);

const JobApplicants = () => {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [scoreFilter, setScoreFilter] = useState(0);
    const [roleFilter, setRoleFilter] = useState("");
    const [dateFilter, setDateFilter] = useState("");
    const [roleSearchQuery, setRoleSearchQuery] = useState("");
    const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
    const roleDropdownRef = useRef(null);
    const [roles, setRoles] = useState([]);
    const [selectedApplicant, setSelectedApplicant] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Pagination states
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        limit: 10,
    });

    // Get clientId from localStorage
    const clientId = localStorage.getItem('clientId');

    useEffect(() => {
        if (clientId) {
            fetchApplications();
        }
        fetchRoles();

        const handleClickOutside = (event) => {
            if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
                setIsRoleDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [clientId]);

    const fetchRoles = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/roles/all`);
            if (res.data.success) {
                const rolesData = res.data.data || [];
                const formattedRoles = rolesData.map((role, index) => ({
                    _id: role._id || index,
                    name: role.roleName || role.name || role
                }));
                // Filter out duplicates and ensure valid names
                const uniqueRoles = Array.from(new Set(formattedRoles.map(r => r.name)))
                    .filter(name => name)
                    .map(name => formattedRoles.find(r => r.name === name));
                setRoles(uniqueRoles);
            }
        } catch (err) {
            console.error("Failed to fetch roles:", err);
        }
    };

    const fetchApplications = async () => {
        if (!clientId) {
            console.error("No clientId found");
            return;
        }
        
        try {
            setLoading(true);
            // GET request with clientId as path parameter
            const res = await axios.get(`${API_BASE_URL}/applications/all/${clientId}`);
            if (res.data.success) {
                setApplications(res.data.applications || []);
            } else {
                setError(res.data.message || "Failed to fetch applications");
                setApplications([]);
            }
        } catch (err) {
            setError("Failed to fetch applications");
            console.error(err);
            setApplications([]);
        } finally {
            setLoading(false);
        }
    };

    const formatDocumentUrl = (filePath) => {
        if (!filePath) return "";
        const relativePath = filePath.includes("uploads")
            ? "uploads/" + filePath.split(/uploads[\\/]/).pop().replace(/\\/g, "/")
            : filePath.replace(/\\/g, "/");
        return `${API_BASE_URL.replace("/api", "")}/${relativePath}`;
    };

    const handleOpenModal = (app) => {
        setSelectedApplicant(app);
        setIsModalOpen(true);
    };

    const handleOpenAssessmentModal = (app) => {
        window.location.href = `/score?search=${app.firstName}`;
    };

    const filteredApplications = applications.filter(app => {
        const query = searchQuery.toLowerCase();
        const matchesSearch =
            `${app.firstName} ${app.lastName}`.toLowerCase().includes(query) ||
            (app.jobId?.role || "").toLowerCase().includes(query) ||
            (app.mobile || "").toLowerCase().includes(query);

        const matchesScore = (app.technicalScore || 0) >= scoreFilter;
        const matchesRole = roleFilter ? (app.jobId?.role === roleFilter) : true;

        let matchesDate = true;
        if (dateFilter) {
            const appDate = new Date(app.appliedAt).toISOString().split('T')[0];
            matchesDate = appDate === dateFilter;
        }

        return matchesSearch && matchesScore && matchesRole && matchesDate;
    });

    // Pagination Handlers
    const handleItemsPerPageChange = (limit) => {
        setPagination({
            currentPage: 1,
            limit: limit,
            totalCount: filteredApplications.length,
            totalPages: Math.ceil(filteredApplications.length / limit)
        });
    };

    const handlePrevPage = () => {
        if (pagination.currentPage > 1) {
            setPagination(prev => ({
                ...prev,
                currentPage: prev.currentPage - 1
            }));
        }
    };

    const handleNextPage = () => {
        if (pagination.currentPage < pagination.totalPages) {
            setPagination(prev => ({
                ...prev,
                currentPage: prev.currentPage + 1
            }));
        }
    };

    const handlePageClick = (page) => {
        setPagination(prev => ({
            ...prev,
            currentPage: page
        }));
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= pagination.totalPages; i++) {
            if (
                i === 1 ||
                i === pagination.totalPages ||
                (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)
            ) {
                pageNumbers.push(i);
            } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
                pageNumbers.push("...");
            }
        }
        return pageNumbers;
    };

    // Update pagination when filtered results change
    useEffect(() => {
        setPagination(prev => ({
            ...prev,
            totalCount: filteredApplications.length,
            totalPages: Math.ceil(filteredApplications.length / prev.limit),
            currentPage: 1
        }));
    }, [filteredApplications.length, searchQuery, scoreFilter, roleFilter, dateFilter]);

    // Calculate pagination
    const indexOfLastItem = pagination.currentPage * pagination.limit;
    const indexOfFirstItem = indexOfLastItem - pagination.limit;
    const currentItems = filteredApplications.slice(indexOfFirstItem, indexOfLastItem);

    // Clear all filters
    const clearFilters = () => {
        setSearchQuery("");
        setScoreFilter(0);
        setRoleFilter("");
        setDateFilter("");
        setRoleSearchQuery("");
    };

    const handleUpdateScore = async (id, field, value) => {
        const numericValue = (field === "status") ? value : Number(value);

        try {
            const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
                applicationId: id,
                [field]: numericValue,
            });
            if (res.data.success) {
                setApplications((prev) =>
                    prev.map((app) => (app._id === id ? { ...app, [field]: numericValue } : app))
                );
            }
        } catch (err) {
            console.error("Update score error:", err);
        }
    };

    const handleResignationStatusUpdate = async (id, status) => {
        try {
            setLoading(true);
            const res = await axios.post(`${API_BASE_URL}/applications/resignation-approval`, {
                applicationId: id,
                status
            });
            if (res.data.success) {
                alert(`Resignation ${status} successfully!`);
                setApplications((prev) =>
                    prev.map((app) => (app._id === id ? { ...app, resignationStatus: status } : app))
                );
                if (selectedApplicant && selectedApplicant._id === id) {
                    setSelectedApplicant({ ...selectedApplicant, resignationStatus: status });
                }
            }
        } catch (err) {
            console.error("Resignation approval error:", err);
            alert("Failed to update resignation status.");
        } finally {
            setLoading(false);
        }
    };

    const Info = ({ label, value }) => (
        <div className="flex justify-between">
            <span className="text-gray-500">{label}</span>
            <span className="font-medium text-gray-800 text-right">
                {value || "N/A"}
            </span>
        </div>
    );

    const ScoreMini = ({ label, score }) => (
        <div>
            <p className="text-xs text-gray-500">{label}</p>
            <p className={`text-sm font-semibold ${score >= 80
                ? "text-green-600"
                : score >= 50
                    ? "text-yellow-600"
                    : "text-red-600"
                }`}>
                {score || 0}
            </p>
        </div>
    );

    // Show loading if no clientId
    if (!clientId) {
        return (
            <div className="w-full min-h-screen p-2 flex items-center justify-center">
                <div className="text-center">
                    <div className="w-10 h-10 border-4 border-indigo-50 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-gray-600">Please login to view applicants</p>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full min-h-screen p-2">
            {/* Filters Section */}
            <div className="p-3 mb-3 bg-white rounded-lg shadow-md">
                <div className="flex flex-wrap items-center gap-2">

                    {/* Search Bar */}
                    <div className="relative flex-1 min-w-[180px]">
                        <FaUserGraduate className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                        <input
                            type="text"
                            placeholder="Search name, mobile, role..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                        />
                    </div>

                    {/* Role Filter Button */}
                    <div className="relative" ref={roleDropdownRef}>
                        <button
                            onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
                            className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
                                roleFilter 
                                    ? 'bg-blue-600 text-white hover:bg-blue-700' 
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
                            }`}
                        >
                            <FaBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
                        </button>
                        
                        {/* Role Filter Dropdown */}
                        {isRoleDropdownOpen && (
                            <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                                <div className="p-2 border-b border-gray-100 bg-gray-50">
                                    <div className="relative">
                                        <FaUserTie className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                                        <input
                                            type="text"
                                            className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                            placeholder="Search roles..."
                                            value={roleSearchQuery}
                                            onChange={(e) => setRoleSearchQuery(e.target.value)}
                                            onClick={(e) => e.stopPropagation()}
                                            autoFocus
                                        />
                                    </div>
                                </div>
                                <div 
                                    onClick={() => {
                                        setRoleFilter('');
                                        setIsRoleDropdownOpen(false);
                                        setRoleSearchQuery('');
                                    }}
                                    className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
                                        !roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                                    }`}
                                >
                                    All Roles
                                </div>
                                {roles
                                    .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
                                    .map((r) => (
                                        <div 
                                            key={r._id}
                                            onClick={() => {
                                                setRoleFilter(r.name);
                                                setIsRoleDropdownOpen(false);
                                                setRoleSearchQuery('');
                                            }}
                                            className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
                                                roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
                                            }`}
                                        >
                                            {r.name}
                                        </div>
                                    ))}
                                {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
                                    <div className="px-3 py-2 text-xs text-gray-400 text-center">
                                        No roles found
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Score Filter */}
                    <div className="relative w-[130px]">
                        <select
                            className="w-full pl-2 pr-6 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent appearance-none"
                            value={scoreFilter}
                            onChange={(e) => setScoreFilter(Number(e.target.value))}
                        >
                            <option value="0">All Scores</option>
                            <option value="60">60% & Above</option>
                            <option value="70">70% & Above</option>
                            <option value="80">80% & Above</option>
                            <option value="90">90% & Above</option>
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center pr-1 pointer-events-none">
                            <FaStar className="text-[8px] text-gray-400" />
                        </div>
                    </div>

                    {/* Date Filter */}
                    <div className="relative w-[130px]">
                        <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-500 pointer-events-none">
                            Date:
                        </span>
                        <input
                            type="date"
                            value={dateFilter}
                            onChange={(e) => setDateFilter(e.target.value)}
                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                            className="w-full pl-12 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                        />
                    </div>

                    {/* Clear Filters Button */}
                    {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter) && (
                        <button
                            onClick={clearFilters}
                            className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition"
                        >
                            Clear
                        </button>
                    )}
                </div>
            </div>

            {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">{error}</div>}

            <div className="p-0 mb-0 bg-white border shadow-lg rounded-2xl">
                {loading ? (
                    <div className="flex flex-col items-center justify-center py-20 gap-4">
                        <div className="w-10 h-10 border-4 border-indigo-50 border-t-indigo-600 rounded-full animate-spin"></div>
                        <p className="text-xs font-bold text-gray-400 animate-pulse uppercase tracking-wider">Loading Applicants...</p>
                    </div>
                ) : filteredApplications.length > 0 ? (
                    <div className="overflow-x-auto bg-white shadow-lg rounded-xl">
                        <table className="min-w-full">
                            <thead className="text-sm text-left text-white bg-gradient-to-r from-green-500 to-blue-600">
                                <tr>
                                    <th className="py-2 text-center">Candidate Name</th>
                                    <th className="py-2 text-center">Applied Role</th>
                                    <th className="py-2 text-center">Contact</th>
                                    <th className="py-2 text-center">Assessment Score (100)</th>
                                    <th className="py-2 text-center">Status</th>
                                    <th className="py-2 text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map((app) => (
                                    <tr key={app._id} className="border-b hover:bg-gray-50 transition-colors">
                                        <td className="px-2 py-2 font-medium text-center">
                                            <div className="text-gray-900 whitespace-nowrap">{app.firstName} {app.lastName}</div>
                                            <div className="text-[10px] text-gray-600">{new Date(app.appliedAt).toLocaleDateString()}</div>
                                        </td>
                                        <td className="px-2 py-2 text-center">
                                            <span className="inline-block px-2 py-1 bg-blue-50 text-blue-600 text-[10px] rounded-full">
                                                {app.jobId?.role || "System Specialist"}
                                            </span>
                                        </td>
                                        <td className="px-2 py-2 text-center text-gray-600">
                                            <div className="flex flex-col items-center">
                                                <span>{app.mobile}</span>
                                            </div>
                                        </td>
                                        <td className="px-2 py-2 text-center">
                                            <input
                                                type="number"
                                                min="0"
                                                max="100"
                                                className="w-20 p-1.5 border rounded-lg text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50"
                                                value={app.technicalScore || 0}
                                                onChange={(e) => handleUpdateScore(app._id, "technicalScore", e.target.value)}
                                            />
                                        </td>
                                        <td className="px-2 py-2 text-center">
                                            <div className="flex flex-col items-center gap-1">
                                                <span className={`px-2 py-1 rounded-full text-[10px] ${app.status === 'Selected' ? 'bg-green-100 text-green-700' :
                                                    app.status === 'Rejected' ? 'bg-red-100 text-red-700' :
                                                        app.status === 'Resigned' ? 'bg-orange-100 text-orange-700' :
                                                            'bg-yellow-100 text-yellow-700'
                                                    }`}>
                                                    {(app.status || "Applied").toUpperCase()}
                                                </span>
                                                {app.status === 'Resigned' && app.resignationStatus === 'Pending' && (
                                                    <span className="text-[8px] font-black text-red-500 animate-pulse uppercase tracking-tighter">
                                                        Resignation Requested
                                                    </span>
                                                )}
                                                {(app.interviewStatus === 'Invited' || app.interviewStatus === 'Rescheduled') && app.candidateInterviewStatus && app.candidateInterviewStatus !== 'Pending' && (
                                                    <span className={`text-[8px] font-black uppercase tracking-tighter ${app.candidateInterviewStatus === 'Confirmed' ? 'text-indigo-600' : 'text-rose-600'}`}>
                                                        Interview {app.candidateInterviewStatus}
                                                    </span>
                                                )}
                                            </div>
                                        </td>
                                        <td className="px-2 py-2 text-center">
                                            <div className="flex justify-center gap-3">
                                                <button
                                                    onClick={() => handleOpenModal(app)}
                                                    className="px-3 py-1 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-xl transition-all duration-300 shadow-sm hover:shadow-md border border-indigo-100 flex items-center justify-center gap-1.5 text-[10px] font-bold"
                                                >
                                                    <FaEye className="text-xs" /> View
                                                </button>
                                                <button
                                                    onClick={() => handleOpenAssessmentModal(app)}
                                                    className="px-3 py-1 bg-gradient-to-r from-indigo-500 to-blue-600 text-white rounded-xl hover:from-indigo-600 hover:to-blue-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                >
                                                    <FaStar className="text-xs" /> Score
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        if (app.resume) {
                                                            window.open(formatDocumentUrl(app.resume), '_blank');
                                                        }
                                                    }}
                                                    className="text-gray-600 hover:text-blue-600 transition flex items-center gap-1 text-[10px]"
                                                    title="View Resume"
                                                >
                                                    <FaDownload className="text-xs" /> Resume
                                                </button>
                                            </div>
                                         </td>
                                     </tr>
                                ))}
                            </tbody>
                         </table>
                        
                        {/* Pagination */}
                        {filteredApplications.length > 0 && (
                            <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 sm:flex-row">
                                <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
                                    <span>Showing</span>
                                    <span className="font-medium">
                                        {indexOfFirstItem + 1}
                                    </span>
                                    <span>to</span>
                                    <span className="font-medium">
                                        {Math.min(indexOfLastItem, filteredApplications.length)}
                                    </span>
                                    <span>of</span>
                                    <span className="font-medium">
                                        {filteredApplications.length}
                                    </span>
                                    <span>results</span>

                                    <select
                                        value={pagination.limit}
                                        onChange={(e) => {
                                            const newLimit = Number(e.target.value);
                                            handleItemsPerPageChange(newLimit);
                                        }}
                                        className="p-1 ml-2 text-sm border rounded-lg"
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                    </select>
                                </div>

                                <div className="flex items-center gap-2 mt-2 sm:mt-0">
                                    <button
                                        onClick={handlePrevPage}
                                        disabled={pagination.currentPage === 1}
                                        className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
                                            pagination.currentPage === 1
                                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                                        }`}
                                    >
                                        Previous
                                    </button>

                                    <div className="flex items-center gap-1">
                                        {getPageNumbers().map((page, index) => (
                                            <button
                                                key={index}
                                                onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
                                                disabled={page === "..."}
                                                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                                                    page === "..."
                                                        ? "text-gray-500 cursor-default"
                                                        : pagination.currentPage === page
                                                        ? "bg-blue-600 text-white"
                                                        : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                                                }`}
                                            >
                                                {page}
                                            </button>
                                        ))}
                                    </div>

                                    <button
                                        onClick={handleNextPage}
                                        disabled={pagination.currentPage === pagination.totalPages}
                                        className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
                                            pagination.currentPage === pagination.totalPages
                                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                                        }`}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="p-12 text-center">
                        <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4 text-gray-300">
                            <FaUserGraduate size={32} />
                        </div>
                        <h3 className="text-lg font-medium text-gray-800">No applicants yet</h3>
                        <p className="text-gray-500">New job applications will appear here once candidates apply.</p>
                    </div>
                )}
            </div>

            {/* Candidate Details Modal */}
            {isModalOpen && selectedApplicant && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
                    <div className="bg-white w-full max-w-3xl rounded-xl shadow-xl relative overflow-hidden">

                        {/* Close Button */}
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className="absolute top-4 right-4 text-gray-400 hover:text-red-500"
                        >
                            <FaTimesCircle size={18} />
                        </button>

                        {/* Header */}
                        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                            <div>
                                <h2 className="text-lg font-semibold text-gray-800">
                                    {selectedApplicant.firstName} {selectedApplicant.lastName}
                                </h2>
                                <p className="text-xs text-gray-500">
                                    {selectedApplicant.jobId?.role || selectedApplicant.role || "Applicant"} 
                                    {selectedApplicant.jobId?.department && ` • ${selectedApplicant.jobId.department}`}
                                </p>
                            </div>

                            <span className={`px-3 py-1 text-xs font-semibold rounded-full
                                ${selectedApplicant.status === "Pending"
                                    ? "bg-yellow-100 text-yellow-700"
                                    : selectedApplicant.status === "Selected"
                                        ? "bg-green-100 text-green-700"
                                        : "bg-red-100 text-red-700"}`}>
                                {selectedApplicant.status}
                            </span>
                        </div>

                        {/* Body */}
                        <div className="p-6 text-sm text-gray-700 space-y-6 max-h-[75vh] overflow-y-auto">

                            {/* Basic Info */}
                            <div>
                                <h3 className="text-xs font-semibold text-gray-500 uppercase mb-3">
                                    Basic Information
                                </h3>
                                <div className="grid grid-cols-2 gap-y-2 gap-x-6">
                                    <Info label="Email" value={selectedApplicant.email} />
                                    <Info label="Mobile" value={selectedApplicant.mobile} />
                                    <Info label="Location" value={selectedApplicant.currentLocation} />
                                    <Info label="Notice Period" value={selectedApplicant.noticePeriod || "Immediate"} />
                                </div>
                            </div>

                            {/* Education */}
                            <div>
                                <h3 className="text-xs font-semibold text-gray-500 uppercase mb-3">
                                    Education
                                </h3>
                                <div className="grid grid-cols-2 gap-y-2 gap-x-6">
                                    <Info label="Qualification" value={selectedApplicant.highestQualification} />
                                    <Info label="Institution" value={selectedApplicant.institution} />
                                    <Info label="Department" value={selectedApplicant.department} />
                                    <Info label="Percentage" value={selectedApplicant.percentage ? `${selectedApplicant.percentage}%` : "N/A"} />
                                </div>
                            </div>

                            {/* Experience */}
                            <div>
                                <h3 className="text-xs font-semibold text-gray-500 uppercase mb-3">
                                    Experience
                                </h3>
                                <div className="grid grid-cols-2 gap-y-2 gap-x-6">
                                    <Info label="Total Exp" value={`${selectedApplicant.experience || 0} Years`} />
                                    <Info label="Company" value={selectedApplicant.companyName} />
                                    <Info label="Current CTC" value={selectedApplicant.currentCTC} />
                                    <Info label="Expected CTC" value={selectedApplicant.expectedCTC} />
                                </div>
                            </div>

                            {/* Skills */}
                            {selectedApplicant.skills && (
                                <div>
                                    <h3 className="text-xs font-semibold text-gray-500 uppercase mb-3">
                                        Skills
                                    </h3>
                                    <div className="flex flex-wrap gap-2">
                                        {selectedApplicant.skills.split(",").map((skill, i) => (
                                            <span
                                                key={i}
                                                className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-md"
                                            >
                                                {skill.trim()}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Scores */}
                            <div>
                                <h3 className="text-xs font-semibold text-gray-500 uppercase mb-3">
                                    Assessment Scores
                                </h3>

                                <div className="grid grid-cols-4 gap-4 text-center">
                                    <ScoreMini label="Tech" score={selectedApplicant.technicalScore} />
                                    <ScoreMini label="Appear" score={selectedApplicant.appearanceScore} />
                                    <ScoreMini label="Knowledge" score={selectedApplicant.workKnowledge} />
                                    <ScoreMini label="Overall" score={selectedApplicant.overallRating} />
                                </div>
                            </div>

                            {/* Interview Confirmation */}
                            {(selectedApplicant.interviewStatus === 'Invited' || selectedApplicant.interviewStatus === 'Rescheduled') && (
                                <div className={`p-4 rounded-xl border ${selectedApplicant.candidateInterviewStatus === 'Confirmed' ? 'bg-indigo-50 border-indigo-100' : selectedApplicant.candidateInterviewStatus === 'Declined' ? 'bg-red-50 border-red-100' : 'bg-amber-50 border-amber-100'}`}>
                                    <div className="flex items-center justify-between mb-2">
                                        <h3 className="text-xs font-bold text-gray-700 uppercase flex items-center gap-2">
                                            <FaCalendarCheck className={selectedApplicant.candidateInterviewStatus === 'Confirmed' ? 'text-indigo-500' : 'text-gray-400'} /> Interview Confirmation
                                        </h3>
                                        <span className={`px-3 py-1 text-[10px] font-bold rounded-full uppercase tracking-widest ${selectedApplicant.candidateInterviewStatus === 'Confirmed' ? 'bg-indigo-100 text-indigo-700' : selectedApplicant.candidateInterviewStatus === 'Declined' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
                                            {selectedApplicant.candidateInterviewStatus || 'Pending'}
                                        </span>
                                    </div>
                                    <div className="grid grid-cols-2 gap-4 mt-3">
                                        <Info label="Scheduled Time" value={selectedApplicant.interviewTime} />
                                        <Info label="Interview Mode" value={selectedApplicant.interviewMode || "Online"} />
                                    </div>
                                    {selectedApplicant.candidateInterviewNote && (
                                        <div className="mt-3 p-3 bg-white rounded-lg border border-gray-100 text-xs text-gray-600 italic">
                                            "{selectedApplicant.candidateInterviewNote}"
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Comment */}
                            {selectedApplicant.comment && (
                                <div className="text-xs bg-gray-50 p-3 rounded-md border text-gray-600">
                                    {selectedApplicant.comment}
                                </div>
                            )}

                            {/* Resignation Details */}
                            {selectedApplicant.status === "Resigned" && (
                                <div className="mt-6 p-6 bg-red-50 rounded-2xl border border-red-100 space-y-4">
                                    <div className="flex items-center justify-between">
                                        <h3 className="text-sm font-bold text-red-800 flex items-center gap-2">
                                            <FaUserTie className="text-red-500" /> Resignation Request
                                        </h3>
                                        <span className={`px-3 py-1 text-[10px] font-bold rounded-full uppercase tracking-widest ${selectedApplicant.resignationStatus === 'Approved' ? 'bg-green-100 text-green-700' :
                                            selectedApplicant.resignationStatus === 'Rejected' ? 'bg-red-100 text-red-700' :
                                                'bg-yellow-100 text-yellow-700'
                                            }`}>
                                            {selectedApplicant.resignationStatus || 'Pending'}
                                        </span>
                                    </div>

                                    {selectedApplicant.resignationLetter && (
                                        <div className="bg-white p-4 rounded-xl border border-red-100 text-xs text-gray-700 italic leading-relaxed max-h-40 overflow-y-auto">
                                            "{selectedApplicant.resignationLetter}"
                                        </div>
                                    )}

                                    {selectedApplicant.resignationStatus === 'Pending' && (
                                        <div className="flex gap-3">
                                            <button
                                                onClick={() => handleResignationStatusUpdate(selectedApplicant._id, "Approved")}
                                                className="flex-1 py-2 bg-green-600 hover:bg-green-700 text-white text-[10px] font-bold uppercase rounded-lg transition-all"
                                            >
                                                Approve Resignation
                                            </button>
                                            <button
                                                onClick={() => handleResignationStatusUpdate(selectedApplicant._id, "Rejected")}
                                                className="flex-1 py-2 bg-red-600 hover:bg-red-700 text-white text-[10px] font-bold uppercase rounded-lg transition-all"
                                            >
                                                Reject Resignation
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
                            <button
                                onClick={() => {
                                    if (selectedApplicant?.resume) {
                                        window.open(formatDocumentUrl(selectedApplicant.resume), "_blank");
                                    }
                                }}
                                className="px-4 py-2 bg-blue-600 text-white text-xs rounded-md hover:bg-blue-700"
                            >
                                View Resume
                            </button>

                            <button
                                onClick={() => setIsModalOpen(false)}
                                className="px-4 py-2 bg-gray-800 text-white text-xs rounded-md hover:bg-black"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default JobApplicants;